// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-state[data-v-2ce43533]{align-items:center;background:#fff;border:1px solid #f4f4f8;border-radius:10px;cursor:pointer;display:flex;height:64px;justify-content:space-between;padding:0 16px;transition:background-color .3s linear}.button-state[data-v-2ce43533]:hover{background:#f4f4f8}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
